import { NgIf } from '@angular/common';
import { Component, Input, HostListener, ElementRef, OnInit } from '@angular/core';
import { WindowStateService } from './monitor-map.service';

@Component({
  selector: 'app-monitor-map',
  templateUrl: './monitor-map.component.html',
  styleUrls: ['./monitor-map.component.scss'],
  standalone: true,
  imports: [NgIf],
})
export class MovableWindowComponent implements OnInit {
  @Input() title = 'Window';
  @Input() isOpen = false;
  @Input() windowType: 'documents' | 'deliveries'; 
  
  position = { x: 0, y: 0 };
  private isDragging = false;
  private offset = { x: 0, y: 0 };
  private readonly WINDOW_WIDTH = 400;
  private readonly WINDOW_HEIGHT = 500;

  constructor(private elRef: ElementRef,
      private windowState: WindowStateService
  ) {}

  ngOnInit() {
    this.setInitialPosition();

      // Mueve el componente directamente al <body>
  const nativeElement = this.elRef.nativeElement as HTMLElement;
  document.body.appendChild(nativeElement);
  }

  private setInitialPosition() {
    // Ajusta estos valores según el ancho de tu sidenav
    const sidenavWidth = 150; 
    const safeMargin = 20;
    
    // Calcula posición inicial para evitar el sidenav
    this.position = {
      x: (window.innerWidth - this.WINDOW_WIDTH) / 2 + (sidenavWidth / 2) + safeMargin,
      y: (window.innerHeight - this.WINDOW_HEIGHT) / 2
    };
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;

    this.position = {
      x: event.clientX - this.offset.x,
      y: event.clientY - this.offset.y
    };
    
    // Limita la posición dentro de los bordes de la ventana
    this.constrainToViewport();
  }

  private constrainToViewport() {
    const minX = 0;
    const minY = 0;
    const maxX = window.innerWidth - this.WINDOW_WIDTH;
    const maxY = window.innerHeight - this.WINDOW_HEIGHT;

    this.position.x = Math.max(minX, Math.min(this.position.x, maxX));
    this.position.y = Math.max(minY, Math.min(this.position.y, maxY));
  }

  @HostListener('document:mouseup')
  onMouseUp() {
    this.isDragging = false;
  }

  startDrag(event: MouseEvent) {
    // Solo permite arrastrar desde el header
    if (event.target !== this.elRef.nativeElement.querySelector('.window-header')) {
      return;
    }

    this.isDragging = true;
    this.offset = {
      x: event.clientX - this.position.x,
      y: event.clientY - this.position.y
    };
    event.preventDefault(); // Evita selección de texto
  }

  close() {
    if (this.windowType) {
      // Usar el servicio para cerrar la ventana específica
      this.windowState.closeWindow(this.windowType, true);
    } else {
      // Comportamiento legacy
      this.isOpen = false;
    }
  }
}